import { useCollectionPager } from 'framework/ViewTypes/hooks';
import { TASK_CONSTRUCTOR_PAGE_SIZE } from '../constants';
import type { TaskConstructorFilters, TaskConstructorListItem } from '../types';
import useTaskConstructorService from '../useTaskConstructorService';
import type { CollectionViewParamsConfig } from 'framework/ViewTypes';
import { FilterCondition } from 'framework/types';

const VIEW_PARAMS_CONFIG: CollectionViewParamsConfig<TaskConstructorFilters> = {
  cache: true,
  filterRules: {
    domain: { condition: FilterCondition.EQ },
    object: { condition: FilterCondition.EQ, values: ['application'] },
  },
  sortableColumns: [],
};

const useTaskConstructorCollection = () => {
  const { search } = useTaskConstructorService();

  return useCollectionPager<TaskConstructorListItem, TaskConstructorFilters>({
    pageSize: TASK_CONSTRUCTOR_PAGE_SIZE,
    viewParamsConfig: VIEW_PARAMS_CONFIG,
    fetchPage: ({ pageNumber, pageSize, filters, searchValue, sort }) =>
      search({
        pageNumber,
        pageSize,
        filters,
        searchValue,
        sort,
      }),
  });
};

export default useTaskConstructorCollection;
